import { TFunction } from "react-i18next";
import {
	AllAvailableItemsApi,
	CsvImportOverviewFormType,
	DryImportMapping,
	ImportCsvOverviewApi,
	ImportCsvOverviewWrongDataApi,
} from "../../../services/types";

export const getImportItemsToMap = (overviewData: ImportCsvOverviewApi): ImportCsvOverviewWrongDataApi => {
	const mappings: Record<string, any> = {};
	const mappingsKeys = Object.keys(overviewData);

	mappingsKeys.forEach((mappingKey) => {
		if (mappingKey === "warnings" || mappingKey === "errors") return;
		mappings[mappingKey] = overviewData[mappingKey];
	});

	return mappings;
};

export const getImportOverviewFormDefaultValues = (
	overviewData: ImportCsvOverviewApi,
	formSelects?: Record<string, any>[]
): CsvImportOverviewFormType => {
	const mappings = getImportItemsToMap(overviewData);
	const mappingsGroups = Object.keys(mappings);
	const mappingDefaultValues: Record<string, any> = {};

	mappingsGroups.forEach((mappingGroup) => {
		mappingDefaultValues[mappingGroup] = [];
		const { mapped } = mappings[mappingGroup];

		mapped.forEach(({ csv_value, mapped_value }) => {
			mappingDefaultValues[mappingGroup].push({
				csv_value,
				db_id: typeof mapped_value === "object" ? mapped_value.id : mapped_value,
			});
		});
	});

	const formInitValue: CsvImportOverviewFormType = { mappings: mappingDefaultValues };

	if (formSelects) {
		formSelects.forEach((formSelect) => {
			formInitValue[formSelect.id] = "";
		});
	}

	return formInitValue;
};

export const getMappingsAvailableItems = (overviewData: ImportCsvOverviewApi) => {
	const mappings = getImportItemsToMap(overviewData);
	const mappingNames = Object.keys(mappings);
	const mappingsAvailableItems: Record<string, AllAvailableItemsApi[]> = {};

	mappingNames.forEach((mappingName) => {
		const { all_available_items } = mappings[mappingName];

		mappingsAvailableItems[mappingName] = all_available_items;
	});

	return mappingsAvailableItems;
};

export const getMappingOptions = (
	mappingAvailableItems: AllAvailableItemsApi[],
	dryImportMappings: DryImportMapping[],
	mappingGroupInSnakeCase: string,
	t: TFunction<"lib">
) => {
	const mappingOptions: { label: string; value: string | number }[] = mappingAvailableItems.map(({ id, name }) => ({
		label: name,
		value: id,
	}));
	const dryImportMapping = dryImportMappings.find((mapping) => mapping.id === mappingGroupInSnakeCase);

	if (dryImportMapping?.hasSkipOption) {
		mappingOptions.unshift({ label: `- ${t("go_component.field.none.title")} -`, value: "skip_mapping" });
	}

	return mappingOptions;
};
